var enterFirstName = "Enter first name";
var enterLastName = "Enter last name";
var enterEmail = "Enter email";
var selectBirthMonth = "Please select birth month";
var enterDayOfMonth = "Please enter day of the month (1-31)";
var enterDayOfFebMonth = "Please enter day of the month (1-29)";
var enterDayOfEvenMonth = "Please enter day of the month (1-30)";

var enterPrimaryPhoneNumber = "Enter primary phone number";
var enterValidSecondaryPhoneNumber =
  "Please enter valid secondary mobile number";

var invalidJobRequisition = "Invalid Job Requisition";
var invalidPeerRequest = "Invalid Peer Request";

var selectHowDoYouKnow = "Please select how you know ";
var enterJobTitle="Please enter the job title";
var enterStartDate="Enter start date";
var enterEndDate="Enter end date";
var endDateGraterThanStartDate="End date must be greater than start date";
var rateSelectedLanguages="Please rate your selected languages or unselect them";
var selectLanguage="Please select a language";
var languageDeleted="Language skill deleted successfully";
var giveRatingForLanguages="Please provide a rating for languages";
var languageUpdatedSuccessfully="Language skills updated successfully";
var chooseSoftSkills="You can choose upto 5 soft skills";
var selectSoftSkill="Please select a soft skill";
var skillDeleted="Skill deleted successfully";
var giveRatingForSkills="Please rate your selected skills or unselect them";
var selectSkill="Please select a skill";
var giveRatingForSkill="Please provide rating for a skill"
var giveRatingForSkillsOrDeleted="Please rate your selected skills or delete them"
var skillUpdatedSuccessfully="Skills updated successfully";
var selectCertification="Please select a certification";
var certificationDeleted="Certification deleted successfully";
var selectEducationType="Select education type";
var enterMajor="Enter your major";
var enterSchoolName="Enter school name";
var enterCity="Enter city";
var enterState="Enter state";
var selectCountry="Select country";
var enterPosition="Enter position";
var enterEmployer="Enter employer";
var enterReason="Please enter reason";
var appliedJobPreviously="You applied for this job previously";
var invalidJob="Invalid job";
var appliedJobSuccessfully="You have successfully applied for the job";
var skillsNotAddedIntoYourProfile="You haven’t added any skills to your profile yet";
var peerRequestUpdated="Peer request updated successfully";
var requestResentSuccessfully="Request resent sucessfully";
var selectPreferredContactType="Select your preferred contact type";
var enterValidEmail="Enter valid email";
var enterPhoneNumber="Enter phone number";
var enterValidPhoneNumber="Enter valid phone number";
var peerRequestAddedSuccessfully="Peer request added successfully";
var peerRequestUpdatedSuccessfully="Peer request updated successfully";
var selectPreciseAddress="Select precise address to get better job matches";
var selectWorkRadius="Please select work radius";
var selectSalaryType="Please select salary type";
var selectEmploymentTerm="Please select employment terms";
var selectJobShift="Please select your preferred job shift";
var enterDesiredSalary="Please enter desired salary";
var enterMaximumSalary="Please enter maximum salary";
var maxSalMustbeGreaterThanMinSal="Maximum salary must be greater than minimum salary";
var enterName="Please enter name";
var selectFileType="Please select file type";
var selectFileToUpload="Please select a file to upload";
var howDoYouKnowThisPerson="Please select how you know this person";

export const Constants = {
  /**BasicInfo */
  enterFirstName: enterFirstName,
  enterLastName: enterLastName,
  enterEmail: enterEmail,
  selectBirthMonth: selectBirthMonth,
  enterDayOfMonth: enterDayOfMonth,
  enterDayOfFebMonth: enterDayOfFebMonth,
  enterDayOfEvenMonth: enterDayOfEvenMonth,
  enterPrimaryPhoneNumber: enterPrimaryPhoneNumber,
  enterValidSecondaryPhoneNumber: enterValidSecondaryPhoneNumber,
  invalidJobRequisition: invalidJobRequisition,
  invalidPeerRequest: invalidPeerRequest,

  /**Professional Relationship */
  selectHowDoYouKnow: selectHowDoYouKnow,
  enterJobTitle:enterJobTitle,
  enterStartDate:enterStartDate,
  enterEndDate:enterEndDate,
  endDateGraterThanStartDate:endDateGraterThanStartDate,

  /**Languages */
  rateSelectedLanguages:rateSelectedLanguages,
  selectLanguage:selectLanguage,
  languageDeleted:languageDeleted,
  giveRatingForLanguages:giveRatingForLanguages,
  languageUpdatedSuccessfully:languageUpdatedSuccessfully,

  /**SoftSkills */
  chooseSoftSkills: chooseSoftSkills,
  selectSoftSkill:selectSoftSkill,

  /**Skills */
  skillDeleted:skillDeleted,
  giveRatingForSkills:giveRatingForSkills,
  selectSkill:selectSkill,
  giveRatingForSkill:giveRatingForSkill,
  giveRatingForSkillsOrDeleted:giveRatingForSkillsOrDeleted,
  skillUpdatedSuccessfully:skillUpdatedSuccessfully,

  /**Certifications */
  selectCertification:selectCertification,
  certificationDeleted:certificationDeleted,

  /**Education */
  selectEducationType:selectEducationType,
  enterMajor:enterMajor,
  enterSchoolName:enterSchoolName,
  enterCity:enterCity,
  enterState:enterState,
  selectCountry:selectCountry,

  /**Experience */
  enterPosition:enterPosition,
  enterEmployer:enterEmployer,

  /**Jobs */
  enterReason:enterReason,
  appliedJobPreviously:appliedJobPreviously,
  invalidJob:invalidJob,
  appliedJobSuccessfully:appliedJobSuccessfully,

  /** Peers*/
  skillsNotAddedIntoYourProfile:skillsNotAddedIntoYourProfile,
  peerRequestUpdated:peerRequestUpdated,

  /**Rating */
  requestResentSuccessfully:requestResentSuccessfully,
  selectPreferredContactType:selectPreferredContactType,
  enterValidEmail:enterValidEmail,
  enterPhoneNumber:enterPhoneNumber,
  enterValidPhoneNumber:enterValidPhoneNumber,
  peerRequestAddedSuccessfully:peerRequestAddedSuccessfully,
  peerRequestUpdatedSuccessfully:peerRequestUpdatedSuccessfully,

  /**Job Preference */
  selectPreciseAddress:selectPreciseAddress,
  selectWorkRadius:selectWorkRadius,
  selectSalaryType:selectSalaryType,
  selectEmploymentTerm:selectEmploymentTerm,
  selectJobShift:selectJobShift,
  enterDesiredSalary:enterDesiredSalary,
  enterMaximumSalary:enterMaximumSalary,
  maxSalMustbeGreaterThanMinSal:maxSalMustbeGreaterThanMinSal,

  /**Resume */
  enterName:enterName,
  selectFileType:selectFileType,
  selectFileToUpload:selectFileToUpload,
  howDoYouKnowThisPerson:howDoYouKnowThisPerson,
};
